import makeStyles from '@ui/utils/makeStyles';

export default makeStyles()((theme) => ({
  graphicItem: {
    textAlign: 'center'
  },
  graphicIcon: {
    marginBottom: 28
  },
  graphicTitle: {
    fontSize: 24,
    fontWeight: 500,
    color: theme.palette.common.black,
    lineHeight: 2,
  },
  graphicDescription: {
    fontSize: 18,
    lineHeight: 1.5,
    color: theme.palette.common.black
  },
}));
